module.exports = __webpack_public_path__ + "media/notification-sound.e3796edb.mp3";